import { Link } from 'react-router-dom';
import logo from '@/assets/biolyn-logo.png';

const productLinks = ['Semaglutide', 'Tirzepatide', 'GHK-Cu', 'Retatrutide'];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A1128] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Company */}
          <div className="md:col-span-4">
            <img src={logo} alt="Biolyn Pharmaceutical B.V." className="h-14 w-auto mb-5" />
            <p className="text-sm text-white/50 leading-relaxed max-w-xs" style={{ fontFamily: 'var(--font-body)' }}>
              European-based supplier of high-purity peptide APIs for pharmaceutical development, research institutions, and cosmetic manufacturers.
            </p>
          </div>

          {/* Products */}
          <div className="md:col-span-2">
            <span className="text-[10px] tracking-widest uppercase text-white/30 block mb-4" style={{ fontFamily: 'var(--font-mono)' }}>Products</span>
            <ul className="space-y-2.5">
              {productLinks.map((p) => (
                <li key={p}>
                  <Link to="/products" className="text-sm text-white/50 hover:text-[#20B8C0] transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>{p}</Link>
                </li>
              ))}
              <li><Link to="/products" className="text-sm text-[#20B8C0] hover:text-white transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>View all &rarr;</Link></li>
            </ul>
          </div>

          {/* Company links */}
          <div className="md:col-span-2">
            <span className="text-[10px] tracking-widest uppercase text-white/30 block mb-4" style={{ fontFamily: 'var(--font-mono)' }}>Company</span>
            <ul className="space-y-2.5">
              <li><a href="/#science" className="text-sm text-white/50 hover:text-[#20B8C0] transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>Science</a></li>
              <li><a href="/#quality" className="text-sm text-white/50 hover:text-[#20B8C0] transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>Quality</a></li>
              <li><a href="/#about" className="text-sm text-white/50 hover:text-[#20B8C0] transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>About</a></li>
              <li><a href="/#rfq" className="text-sm text-white/50 hover:text-[#20B8C0] transition-colors duration-150" style={{ fontFamily: 'var(--font-body)' }}>Request a Quote</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <span className="text-[10px] tracking-widest uppercase text-white/30 block mb-4" style={{ fontFamily: 'var(--font-mono)' }}>Contact</span>
            <div className="space-y-2.5">
              <p className="text-sm text-white/50" style={{ fontFamily: 'var(--font-mono)' }}>info@biolynpharma.com</p>
              <p className="text-sm text-white/50" style={{ fontFamily: 'var(--font-body)' }}>Amsterdam, The Netherlands</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30" style={{ fontFamily: 'var(--font-mono)' }}>
            &copy; {new Date().getFullYear()} Biolyn Pharmaceutical B.V. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/admin/login" className="text-xs text-white/20 hover:text-white/40 transition-colors duration-150" style={{ fontFamily: 'var(--font-mono)' }} data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
